import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import WetSlider from './WetSlider.js';

class MidiDelayEffectComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    render() {
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                <div className="clear-fix"/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Steps Delay'}
                  parameter={this.props.effect.delayTimeParameter}
                  automation={this.props.automation}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={1}
                  max={64}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Repeats'}
                  parameter={this.props.effect.repeatsParameter}
                  automation={this.props.automation}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={1}
                  max={32}/>
                <WetSlider
                  effectNumber={this.props.effectNumber}
                  sequencerEngine={this.props.sequencerEngine}
                  automation={this.props.automation}
                  selectedParameter={this.props.selectedParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  effect={this.props.effect}/>
 
              </ConditionedComponent>
            </div>
        );
    }
}

export default MidiDelayEffectComponent;
